/**
 * SC-06 — the one AI call: a hidden v2 turn forced to `ppt_rephrase_slide`, in its own thread bucket
 * so it never shows up as the user's conversation. Resolves with the raw reply; throws a showable Error.
 */

import { ChatHttpError, streamChat } from "../../../../../chat/services/api";
import type { RefreshTokenFn } from "../../../../../shared/api/fetchWithRefresh";
import { REPHRASE_COPY } from "../../../const";

export const REPHRASE_SKILL_KEY = "ppt_rephrase_slide";
const REPHRASE_CONTEXT_ID = "aiva-ppt-rephrase-slide";

function failureMessage(err: unknown): string {
  if (err instanceof ChatHttpError) {
    if (err.status === 401) return "Your sign-in has expired. Please Sign in to continue.";
    if (err.status === 429 || err.status >= 500) return "AiVA is busy right now. Try again in a moment.";
  }
  return REPHRASE_COPY.REQUEST_FAILED;
}

export async function requestRewrites(options: {
  message: string;
  apiToken: string | null;
  refresh?: RefreshTokenFn;
  signal?: AbortSignal;
}): Promise<string> {
  let reply = "";
  let refused: string | null = null;
  try {
    await streamChat(
      options.message,
      [],
      null,
      "powerpoint",
      options.apiToken,
      (ev) => {
        if (ev.event === "token" && ev.data.content) reply += ev.data.content;
        else if (ev.event === "error" || ev.event === "guardrail_flagged") {
          refused = ev.data.message ?? REPHRASE_COPY.REQUEST_FAILED;
        } else if (ev.event === "paused" || ev.event === "approval_required") {
          refused = REPHRASE_COPY.REQUEST_FAILED;
        }
      },
      {
        forcedSkillKey: REPHRASE_SKILL_KEY,
        hiddenTurn: true,
        contextId: REPHRASE_CONTEXT_ID,
        signal: options.signal,
        refresh: options.refresh,
      },
    );
  } catch (err: unknown) {
    if (options.signal?.aborted) throw err;
    throw new Error(failureMessage(err));
  }
  if (refused) throw new Error(refused);
  return reply;
}
